/**
* This file is part of "Zona franca"
* Copyright (c) 2022
* Zona franca
* All rights reserved
*
* @author Yhonaiker Moncada <ymoncada@technisupport.com>

* @version 1.0
*/

const formatedInput = (number) => {
  const formatedNumber = String(number).replaceAll(",", "");
  return new Intl.NumberFormat("en-Us").format(formatedNumber);
};

export { formatedInput };
